<template>
  <div
    v-if="results"
    class="h-full"
  >
    <VueApexCharts
      height="100%"
      :options="chartOptions"
      :series="series"
    />
  </div>
</template>

<script>
import currencyMixin from '@/mixins/currency'
import { formatSpaceUnit } from '@/lib/spaceUnit'
import dateMixin from '@/lib/date'
import brandingMixin from '@/mixins/branding'

import VueApexCharts from 'vue-apexcharts'
import { shadeColor } from '@/lib/color'

const de = {
  name: 'de',
  options: {
    shortMonths: [
      'Jan',
      'Feb',
      'Mär',
      'Apr',
      'Mai',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Okt',
      'Nov',
      'Dez'
    ]
  }
}

const en = {
  name: 'en',
  options: {
    shortMonths: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ]
  }
}

export default {
  components: { VueApexCharts },

  mixins: [currencyMixin, dateMixin, brandingMixin],

  props: {
    results: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      chartOptions: {
        chart: {
          locales: [de, en],
          defaultLocale: this.$i18n.locale || 'en',
          type: 'area',
          parentHeightOffset: 0,
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth',
          width: 0
        },
        fill: {
          opacity: 1,
          type: 'solid'
        },
        legend: {
          show: true,
          position: 'top'
        },
        xaxis: {
          type: 'datetime',
          tooltip: {
            enabled: false
          }
        }
      }
    }
  },

  computed: {
    series () {
      if (this.results) {
        const maxSeries = []
        const avgSeries = []
        const minSeries = []
        const chart = []

        this.results.property.valueTrend.forEach(item => {
          maxSeries.push(item.valueRange?.max)
          avgSeries.push(item.value)
          minSeries.push(item.valueRange?.min)
        })

        maxSeries.filter(Boolean).length &&
          chart.push({ data: maxSeries.reverse(), name: this.$t('labels.maximum') })

        avgSeries.filter(Boolean).length &&
          chart.push({ data: avgSeries.reverse(), name: this.$t('labels.average') })

        minSeries.filter(Boolean).length &&
          chart.push({ data: minSeries.reverse(), name: this.$t('labels.minimum') })

        this.updateLabels(this.results.property)
        return chart
      }
      return []
    },
    customColors () {
      return [shadeColor(this.primaryColor, -80), shadeColor(this.primaryColor, 40), this.primaryColor]
    }
  },

  methods: {
    formatSpaceUnit,
    updateLabels (property) {
      const context = this
      const dates = property.valueTrend.map(({ date }) => date)
      this.chartOptions = {
        ...this.chartOptions,
        labels: dates.reverse(),
        yaxis: {
          labels: {
            formatter (val) {
              return context.formatPrice(val)
            }
          }
        },
        colors: this.customColors
      }
    }
  }
}
</script>
